<div class="accordion-group" id="accordion" role="region" aria-labelledby="accordion-heading">
  <div *ngFor="let item of items; let i = index" class="accordion">
    <h2 class="accordion-header" id="heading{{ i }}">
      <button class="accordion-button" type="button" (click)="toggle(i)" [class.collapsed]="activeIndex !== i"
        [attr.aria-expanded]="activeIndex === i ? 'true' : 'false'" [attr.aria-controls]="'collapse' + i" tabindex="0"
        [attr.aria-label]="
          activeIndex === i
            ? 'Colapsar ' + item.title
            : 'Expandir ' + item.title
        ">
        <div class="me-3">
          <img *ngIf="item.icon_url; else defaultIcon" [src]="item.icon_url" alt="Ícone de {{ item.title }}" width="40"
            height="40" class="icon-image" />
        
          <ng-template #defaultIcon>
            <!-- <img src="https://placehold.co/40x40?text=FAQ" alt="Ícone padrão" width="40" height="40" class="icon-image" /> -->
          </ng-template>
        </div>

        {{ item.title }}
        <i class="bi bi-chevron-down" [ngClass]="{ rotated: activeIndex === i }" aria-hidden="true"></i>
      </button>
    </h2>
    <div *ngIf="activeIndex === i" class="accordion-collapse collapse show" [attr.id]="'collapse' + i"
      [attr.aria-labelledby]="'heading' + i" [attr.aria-hidden]="activeIndex !== i" aria-live="assertive">
      <div class="accordion-body">
        <div class="rich-text" [innerHTML]="item.description | richTextHtml"></div>
      </div>
    </div>
  </div>
</div>